import { Component, Inject, OnInit, ViewChild, TemplateRef} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


import { GestockService } from '../services/gestock.service';


@Component({
  selector: 'app-price-dialog',
  templateUrl: './price-dialog.component.html',
  styleUrls: ['./price-dialog.component.css']
})
export class PriceDialogComponent implements OnInit {

  priceForm: FormGroup;

  gros: number;
  demiGros: number;
  detail: number;

  product : any ;

  retourClientWS : any ;



  etatreq = "" ;

  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;

  spinnerDialogRef : any ;

  samacaabiyoonwii : any ;

  longbi = 1 ;
  pricingType: string = '';

  constructor(
    public dialogRef: MatDialogRef<PriceDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
          private configServer: GestockService, 
                         public dialog: MatDialog) {

    const prices = data.product?.prices || {};
    this.gros = prices.gros ?? 0;
    this.demiGros = prices.demiGros ?? 0;
    this.detail = prices.detail ?? 0;

    this.longbi = data.longbi ?? 1;
    this.product = data.product;
    this.pricingType = data.pricingType || '';

  }


  ngOnInit(){
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;    
  }

  isEditable(priceCategory: string): boolean {
    if (this.longbi != 1) return false;
    if (!this.pricingType) return true;

    const pType = this.pricingType.toLowerCase();
    if (pType === 'gros') {
      return priceCategory === 'gros';
    }
    if (pType === 'demi-gros' || pType === 'demigros') {
      return priceCategory === 'demiGros';
    }
    return priceCategory === 'detail';
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    //this.dialogRef.close(this.priceForm.value);
  }

  mettreAjourPrixArticleBi(){
    let prixDeVente = { gros: this.gros, demiGros: this.demiGros, detail: this.detail } ;
    this.openSpinnerDialog() ;
    this.configServer.mettreAjourPrixArticleBi(this.samacaabiyoonwii, prixDeVente, this.product).then( (retourbi) => {
      this.closeSpinnerDialog() ;
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      if(statutreq==1){
        this.etatreq='successful' ;
        if (this.product && this.product.prices) {
          this.product.prices.gros = this.gros;
          this.product.prices.demiGros = this.demiGros;
          this.product.prices.detail = this.detail;
        }
        console.log("Mbirr Yi Matna") ;
      }
      else{
        this.etatreq='failed' ;
        console.log("Failed") ;
      }
    }) ;    
  }

  save() {
    if (this.product && this.product.prices) {
      this.product.prices.gros = this.gros;
      this.product.prices.demiGros = this.demiGros;
      this.product.prices.detail = this.detail;
    }
    this.dialogRef.close({
      gros: this.gros,
      demiGros: this.demiGros,
      detail: this.detail
    });
  }



  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }


  close() {
    this.dialogRef.close();
  }


}
